








































































































































































import InfoTooltip from '@/components/common/InfoTooltip.vue';
import InputField from '@/components/common/inputs/InputField.vue';
import MappedSelectionField from '@/components/common/inputs/MappedSelectionField.vue';
import TextArea from '@/components/common/inputs/TextArea.vue';
import Well from '@/components/common/Well.vue';
import WellItem from '@/components/common/WellItem.vue';
import FormSection from '@/components/details/FormSection.vue';
import { PhaseKeys } from '@/models/phase';
import { ErrorModule } from '@/store/modules/error';
import { ProcessModule, ProcessState } from '@/store/modules/process';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Well,
    InfoTooltip,
    TextArea,
    FormSection,
    MappedSelectionField,
    InputField,
    WellItem
  }
})
export default class TimeAndProcessForm extends Vue {
  PhaseKeys = PhaseKeys;

  yesNoItems = [
    { value: null, text: '' },
    { value: true, text: 'はい' },
    { value: false, text: 'いいえ' }
  ];

  secondRules: Array<(value: string) => boolean | string> = [
    value => Number.isInteger(Number(value)) || '秒は整数で入力してください',
    value => parseInt(value, 10) < 60 || '秒は59以下で入力してください',
    value => parseInt(value, 10) >= 0 || '秒に負の値は入力できません'
  ];

  minuteRules: Array<(value: string) => boolean | string> = [
    value => Number.isInteger(Number(value)) || '分は整数で入力してください',
    value => parseInt(value, 10) < 60 || '分は59以下で入力してください',
    value => parseInt(value, 10) >= 0 || '分に負の値は入力できません'
  ];

  hoursRules: Array<(value: string) => boolean | string> = [
    value => Number.isInteger(Number(value)) || '時間は整数で入力してください',
    value => parseInt(value, 10) >= 0 || '時間に負の値は入力できません'
  ];

  get state() {
    return ProcessModule;
  }

  get timeSpendOccurancesPerEmployee() {
    return Number(ProcessModule.timeSpendOccurancesPerEmployee);
  }

  get timeSpendPerOccurance() {
    return ProcessModule.timeSpendPerOccurance == null ? null : Number(ProcessModule.timeSpendPerOccurance);
  }

  get expectedDevelopmentTime() {
    return ProcessModule.expectedDevelopmentTime == null ? null : Number(ProcessModule.expectedDevelopmentTime);
  }

  get timeSpendPercentageDigital() {
    return Number(ProcessModule.timeSpendPercentageDigital);
  }

  get timeSpendTotal() {
    if (this.timeSpendOccurancesPerEmployee == null || this.timeSpendPerOccurance == null) {
      return 0;
    } else {
      return this.timeSpendOccurancesPerEmployee * this.timeSpendPerOccurance;
    }
  }

  get timeSpendHours() {
    const hours = (this.timeSpendTotal / 60).toFixed(2) || '0';
    return hours;
  }

  // Number of times this process is repeated yearly * amount of time required pr. process in minutes / 60 * automation potential / 100
  get exptectedYearlyPotential() {
    if (this.timeSpendPercentageDigital == null) {
      return '0';
    } else {
      const hours = ((this.timeSpendTotal / 60) * (this.timeSpendPercentageDigital / 100)).toFixed(2) || '0';
      return hours;
    }
  }

  get minutesAndSecondsPerOccurance(): { minutes: number | null; seconds: number | null } {
    if (this.timeSpendPerOccurance == null) {
      const minutes = null;
      const seconds = null;
      return { minutes, seconds };
    } else {
      const minuteString = this.timeSpendPerOccurance.toString();
      const minutes = parseInt(minuteString ?? '', 10); // remove decimals
      const seconds = (this.timeSpendPerOccurance - minutes) * 60; // remove minute part and convert decimals to seconds
      return { minutes, seconds };
    }
  }

  get hoursAndMinutesExpectedDevelopmentTime(): { hours: number | null; minutes: number | null } {
    if (this.expectedDevelopmentTime == null) {
      const hours = null;
      const minutes = null;
      return { hours, minutes };
    } else {
      const hoursString = this.expectedDevelopmentTime.toString()
      const hours = parseInt(hoursString ?? '', 10); // remove decimals
      const minutes = (this.expectedDevelopmentTime - hours) * 60; // remove hour part and convert decimals to minutes
      return { hours, minutes };
    }
  }

  get shouldBeOpen(): boolean {
    const href = window.location.href;
    const url = new URL(href);
    const params = url.searchParams;
    let search = null;
    for (const [key, value] of params) {
      if (key === 'search') {
        search = value;
        break;
      }
    }

    if (search != null) {
      const searchLowerCase = search.toLowerCase();
      if (this.state.timeSpendComment?.toLowerCase().includes(searchLowerCase)) {
        return true;
      }
    }

    return false;
  }

  update(state: Partial<ProcessState>) {
    ProcessModule.update(state);
  }

  isInErrors(name: string) {
    return ErrorModule.errorInField(ErrorModule.timeAndProcess, name);
  }

  updateTimeSpentPerOccurance({ minutes, seconds }: { minutes: string; seconds: string }) {
    let newSeconds = null;
    if (seconds !== '' && seconds != null) {
      newSeconds = parseInt(seconds, 10);
    } else if (seconds == null) {
      newSeconds = this.minutesAndSecondsPerOccurance.seconds;
    }
    
    let newMinutes = null;
    if (minutes !== '' && minutes != null) {
      newMinutes = parseInt(minutes, 10);
    } else if (minutes == null) {
      newMinutes = this.minutesAndSecondsPerOccurance.minutes;
    }

    if (newSeconds == null && newMinutes == null) {
      ProcessModule.update({ timeSpendPerOccurance: `${null}` });
    } else {
      if (newSeconds == null) {
        newSeconds = 0;
      }

      if (newMinutes == null) {
        newMinutes = 0
      }
      
      const timeSpendPerOccurance = newMinutes + newSeconds / 60;
      ProcessModule.update({ timeSpendPerOccurance: `${timeSpendPerOccurance}` });
    }
  }

  updateExpectedDevelopmentTime({ hours, minutes }: { hours: string; minutes: string }) {
    let newHours = null;
    if (hours !== '' && hours != null) {
      newHours = parseInt(hours, 10);
    } else if (hours == null) {
      newHours = this.hoursAndMinutesExpectedDevelopmentTime.hours;
    }
    
    let newMinutes = null;
    if (minutes !== '' && minutes != null) {
      newMinutes = parseInt(minutes, 10);
    } else if (minutes == null) {
      newMinutes = this.hoursAndMinutesExpectedDevelopmentTime.minutes;
    }

    if (newHours == null && newMinutes == null) {
      ProcessModule.update({ expectedDevelopmentTime: `${null}` });
    } else {
      if (newHours == null) {
        newHours = 0;
      }

      if (newMinutes == null) {
        newMinutes = 0
      }
      
      const expectedDevelopmentTime = newHours + newMinutes / 60;
      ProcessModule.update({ expectedDevelopmentTime: `${expectedDevelopmentTime}` });
    }
  }
}
